// js/pages/member.js

import { initModal } from "@/js/common/modal.js";

export function initMember() {
  initMemberModal();
  initMemberModalChange();
}

function initMemberModal() {
  initModal({
    openSelector: ".js-member-modal-open",
    modalSelector: ".js-member-modal",
    closeSelector: ".js-member-modal-close",
    duration: 300,
    bodyClass: "is-modal-open",
  });
}

function initMemberModalChange() {
  const changeButtons = document.querySelectorAll(".js-member-modal-change");

  if (changeButtons.length === 0) return;

  changeButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();

      const targetId = button.dataset.modalTarget;

      if (!targetId) return;

      switchModalById(targetId);
    });
  });
}